import type { ComponentType } from 'react'
import type { Icone } from '../atoms/CatalogoDialog'

/** O que a tela precisa de uma condição além do catálogo do `@acme/core`. */
export interface CondicaoUi {
    icone: Icone
    /** Parâmetros que a condição recebe ao ser escolhida — já válidos no catálogo. */
    parametrosIniciais: Record<string, unknown>
    /** Campos de `parametros` no formulário; ausente, não há o que configurar. */
    Parametros?: ComponentType
    /** Resumo dos parâmetros na lista; ausente, usa a descrição do catálogo. */
    resumir?: (parametros: Record<string, unknown>) => string
}

export const OPCOES_COMPARACAO = [
    { value: 'acima', label: 'acima de' },
    { value: 'abaixo', label: 'abaixo de' },
] as const

export const descreverLimite = (parametros: Record<string, unknown>) =>
    `${parametros.comparacao ?? 'acima'} de ${parametros.limite}`

export function contar(ids: unknown, singular: string, plural: string): string {
    const total = Array.isArray(ids) ? ids.length : 0
    return `${total} ${total === 1 ? singular : plural}`
}
